import {AnalyticEventCategory, AnalyticEventType, type ShareActivityLinkAnalytics} from '../../../../shared/entity_datas/EntityDatas.ts'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup.ts'
import {setElementInnerHTML, createDivIn, createButtonIn, setElementOnClick, createImgIn, createParagraphIn} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {CA} from '../analytics/Analytics.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {audioManager, AudioType} from '../Sound.ts'
import {ReferralProgramUtils} from '../referral/ReferralProgramUtils.ts'
import {type ReferralReward} from '../../../../shared/ReferralProgram.ts'
import {type TranslationObject, type TranslationOptions} from '@colonist/i18n'
import {clientI18n} from '../ClientI18n.ts'

export class ViewPopupReferFriends extends ViewPopup {
    constructor(referralReward: ReferralReward, userReferralCount: number,) {
        super({key: 'strings:storePage.sections.referral.popup.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            () => undefined,
            () => undefined,
            true,
            {
                showXButton: false,
                showCheckButton: false,
                showXonHeader: true,
            })

        this.body.classList.add('popup-body-refer-friends')

        const container = createDivIn(this.body, 'invite_friends_container')

        const imageWrapper = createDivIn(container, 'popup-subscription-in-room-items-wrapper', '')
        const imageCard = createDivIn(imageWrapper, 'popup-subscription-in-room-item-img', '')
        const imgElement = createImgIn(imageCard, referralReward.image)
        imageWrapper.appendChild(imageCard)

        const invitesLeft = referralReward.referralCount - userReferralCount

        const options: TranslationOptions = {
            ...referralReward.name.options,
            context: 'one',
        }
        const translatedName = clientI18n.t(referralReward.name.key, options).toLowerCase()

        const text: TranslationObject = {
            key: 'strings:storePage.sections.referral.popup.body',
            options: {
                context: invitesLeft == 1 ? 'one' : 'other',
                invitesLeft: invitesLeft,
                itemCategory: translatedName,
            },
        }

        createParagraphIn(container, text, 'popup-membership-body')

        const body = createDivIn(container, 'invite_friends_body')

        const link = createDivIn(body, 'room_center_link')
        const button = createButtonIn(body, 'btn_general btn_general_copylink', {key: 'strings:roomPage.options.inviteFriends.copy'})

        void ViewPopupReferFriends.initializeReferralLink(link, button, referralReward)

        this.removeFooter()
        this.show()

        ViewPopupReferFriends.sendCopyLinkAnalytic(referralReward.analyticsPopupTriggered)
    }

    private static async initializeReferralLink(link: HTMLDivElement, button: HTMLButtonElement, referralReward: ReferralReward) {
        const linkText = await ReferralProgramUtils.getReferralLinkForSharing()

        setElementOnClick(button, () => {
            audioManager.play(AudioType.Click)
            void navigator.clipboard.writeText(linkText)
            setElementInnerHTML(button, {key: 'strings:roomPage.copiedLink'})
            setTimeout(() => {
                setElementInnerHTML(button, {key: 'strings:roomPage.options.inviteFriends.copy'})
            }, 1500)
            ViewPopupReferFriends.sendCopyLinkAnalytic(referralReward.analyticsPopupSuccess)
        })

        setElementInnerHTML(link, {key: 'strings:colonistCommon.utils.#buffer', options: {value: linkText}})
        link.addEventListener('copy', () => ViewPopupReferFriends.sendCopyLinkAnalytic(referralReward.analyticsPopupSuccess))
    }

    private static sendCopyLinkAnalytic(analyticType: ShareActivityLinkAnalytics) {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ReferralAnalytics,
            category: UIUtilsEjsVariables.isUserOnMobile ? AnalyticEventCategory.MobileStoreReferralProgramReferFriends : AnalyticEventCategory.WebStoreReferralProgramReferFriends,
            floatValue: analyticType,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}
